const reviews_carousel = () => {

    $('.reviews_carousel--wrapper_inner').slick({
        dots: false,
        infinite: true,
        centerMode: true,
        centerPadding: 20,
        prevArrow: '',
        nextArrow: '.reviews_carousel--wrapper_next',
    });

};

export default reviews_carousel;